<template>
    <div class="mask" id="mask">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "sd-mask",
    mounted() {
        document.body.style.overflow = "hidden";
    },
    beforeDestroy() {
        document.body.style.overflow = "auto";
    }
}
</script>

<style lang="scss" scoped>
    .mask {
        position: fixed;
        width: 100% !important;
        height: 100% !important;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.4);
        z-index: 9;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/mask.vue